<script setup lang="ts">
  import OnboardingSlideContent from './OnboardingSlideContent.vue'

  interface Props {
    topRatio?: number
    bottomRatio?: number
    gap?: string
    mode?: 'center' | 'opposite'
  }

  const props = withDefaults(defineProps<Props>(), {
    topRatio: 50,
    bottomRatio: 50,
    gap: '0px',
    mode: 'center',
  })
</script>
<template>
  <onboarding-slide-content>
    <div class="split-container" :style="{ gap: props.gap }">
      <div
        class="split-section top-section"
        :class="{
          'justify-center': props.mode === 'center',
          'justify-end': props.mode === 'opposite',
        }"
        :style="{
          height: `${props.topRatio}%`,
        }"
      >
        <slot name="top"></slot>
      </div>
      <div
        class="split-section bottom-section"
        :class="{
          'justify-center': props.mode === 'center',
          'justify-start': props.mode === 'opposite',
        }"
        :style="{
          height: `${props.bottomRatio}%`,
        }"
      >
        <slot name="bottom"></slot>
      </div>
    </div>
  </onboarding-slide-content>
</template>
<style scoped>
  .split-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .split-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .justify-center {
    justify-content: center;
  }

  .justify-start {
    justify-content: start;
  }

  .justify-end {
    justify-content: end;
  }

  .top-section {
    border-bottom: 0;
  }

  .bottom-section {
    border-top: 0;
  }
</style>
